<template>
  <div class="el-core__header__left header-container">
    <div class="emd-sidemenu__trigger">
      <button-menu
        :btnMenuState="isOpen"
        @btnMenuClicked="toggleAppMenu"
      />
    </div>
    <div
      class="emd-control"
      :class="classList"
      data-onboarding="navigation"
      v-click-outside="closeDropdown"
    >
      <div class="emd-control__wrapper">
        <span class="emd-control__status status">
          {{ $t(status.label) }}
        </span>
        <div class="emd-control__link">
          <div class="emd-control__icon header-icon">
            <logo-stone-rebrand-icon class="stone-rebrand-logo" />
          </div>
          <div class="eu-display_flex eu-column company-container">
            <span
              v-if="accountName"
              id="accountName"
              class="company-name"
            >
              {{ accountName }}
            </span>
            <span
              class="company-document"
              :title="companyDocument"
            >
              {{ companyDocument }}
            </span>
          </div>
        </div>
        <emd-tippy
          id="account"
          :type="'ghost'"
          :position="'left'"
          :content="$t('tooltip.account')"
        >
          <button
            class="emd-action-button header-button"
            @click="contextDropdown"
          >
            <emerald-icon icon="direction" />
          </button>
        </emd-tippy>
      </div>
      <div class="header-dropdown emd-control__dropdown jsControlAccDropdown">
        <app-context-select />
      </div>
    </div>
    <div class="eu-ml_4 eu-display_none eu-display_block_md">
      <div class="emd-logo-custom__image"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { EmdTippy, EmeraldIcon } from 'emerald-vue/src/components'

import ButtonMenu from '@/components/project/atoms/ButtonMenu.vue'
import AppContextSelect from '@/components/project/ui/menu/ContextSelect/AppContextSelect.vue'
import LogoStoneRebrandIcon from '@/components/project/atoms/LogoStoneRebrandIcon.vue'

import { STATUS_ACCOUNT } from './status-account.enum'

export default {
  name: 'AppCoreHeaderLeft',
  components: {
    ButtonMenu,
    AppContextSelect,
    EmdTippy,
    EmeraldIcon,
    LogoStoneRebrandIcon
  },
  props: {
    account: {
      type: Object,
      required: true
    },
    isOpen: Boolean,
    companyDocument: String
  },
  data () {
    return {
      contextOpen: false
    }
  },
  computed: {
    ...mapGetters(['merchantIsDelinquent', 'statusAccount', 'isTestAccount']),
    accountName () {
      return this.account.name
    },
    status () {
      if (!this.account) return STATUS_ACCOUNT.inactive
      if (this.merchantIsDelinquent) return STATUS_ACCOUNT.blocked
      if (this.isTestAccount) return STATUS_ACCOUNT.test

      const status = this.statusAccount?.key ?? STATUS_ACCOUNT.inactive

      return (
        Object.values(STATUS_ACCOUNT).find(el => el.status.includes(status)) ??
        STATUS_ACCOUNT.inactive
      )
    },
    classList () {
      return {
        _open: this.contextOpen,
        [this.status.style]: true
      }
    }
  },
  methods: {
    contextDropdown () {
      this.contextOpen = !this.contextOpen
    },
    closeDropdown () {
      this.contextOpen = false
    },
    toggleAppMenu () {
      this.$emit('appMenuClicked')
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "tooltip": {
        "backoffice": "Retornar ao backoffice",
        "account": "Selecionar Conta"
      },
      "status": {
        "test": "Conta teste",
        "inactive": "Inativo",
        "blocked": "Bloqueado",
        "active": "Ativo",
        "pending": "Pendente"
      }
    },
    "en-US": {
      "tooltip": {
        "backoffice": "Return to Backoffice",
        "account": "Select Account"
      },
      "status": {
        "test": "Test account",
        "inactive": "Inactive",
        "blocked": "Blocked",
        "pending": "Pending"
      }
    }
  }
  </i18n>

<style scoped>
.header-icon {
  margin-right: 8px;
  width: 32px;
  height: 32px;
}
.company-container {
  width: calc(100% - 40px);
}
.company-name {
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.company-document {
  font-size: 12px;
  color: #8b8b92;
}
.status {
  left: 16px;
  font-size: 10px;
}
.pagarme-icon {
  max-width: 32px;
  height: 32px;
}
.stone-rebrand-logo {
  display: block;
  width: 32px;
  height: 32px;
}
.header-button {
  padding: 0;
}
.header-dropdown {
  top: 28px !important;
}
.header-dropdown:after {
  content: ' ';
  position: absolute;
  top: -14px;
  right: 0px;
  border-left: 14px solid transparent;
  border-right: 14px solid transparent;
  border-bottom: 14px solid #fff;
}
.header-container {
  display: block !important;
}

.emd-control._status_test .emd-control__status {
  background-color: var(--brand--le--info-color--base);
  color: white;
}

.emd-control__status {
  padding: 0;
}

@media only screen and (max-width: 768px) {
  .status {
    left: 8px;
    height: 12px;
  }
  .header-container {
    display: flex !important;
  }
}
</style>
